const _files: Record<string, File> = {};

export const storePrescriptionFile = (cartItemId: string, file: File | null) => {
  if (file) _files[cartItemId] = file;
  else delete _files[cartItemId];
};

export const getPrescriptionFile = (cartItemId: string): File | null =>
  _files[cartItemId] ?? null;

export const getAllPrescriptionFiles = (): Record<string, File> => ({ ..._files });

export const clearPrescriptionFiles = () => {
  for (const k of Object.keys(_files)) delete _files[k];
};
